import { HelloSignClosingTask, Task } from 'sellDirect/helpers/closingTasks';

/**
 * Checks if a task is completed
 */
export const isTaskComplete = (task: Task<{ __typename: string }> | undefined) => {
  if (task === undefined) {
    return false;
  }

  return !!task.complete;
};

/**
 * Checks if a hello-sign task is completed
 */
export const isHelloSignTaskComplete = (task: HelloSignClosingTask | undefined) => {
  if (task === undefined) {
    return false;
  }
  return task.complete || !!task.taskable.completedAt;
};
